import Report from '@klook/client-report'

const klkReport = new Report({
    platform: "desktop", 
    url: window.KLK_KV_CONFIG.LOGQUERY_URL_V3
})

export default klkReport; 